import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import { useSegmentationForm, useSegmentationFormActions } from '../_form/SegmentationFormHandler'
import ChecklistTypesCardPicker from '../../../../containers/checklistTypes/select/cardPicker/ChecklistTypesCardPicker'

export const useChecklistTypesStepDef = () => {
  const { t } = useTranslation('editSegmentation')
  const form = useSegmentationForm()

  return useMemo(
    () => ({
      title: t('checklistTypes.title'),
      subtitle: t('checklistTypes.subtitle'),
      Component: ChecklistTypes,
      validate: () => {
        if (!form.checklistTypes.length) return [false, t('checklistTypes.selectTypeRequired')]
        return [true]
      }
    }),
    [form.checklistTypes, t]
  )
}

const ChecklistTypes = () => {
  const form = useSegmentationForm()
  const { handleChange } = useSegmentationFormActions()

  return (
    <ChecklistTypesCardPicker
      value={form.checklistTypes}
      idField="id"
      onChange={handleChange('checklistTypes')}
      multiple
      useSelectAll
    />
  )
}

export default ChecklistTypes
